/**
 * @flow
 * @relayHash d6e5532c848d6c0758fd7c1d142a00b4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CheckoutBillTable_bill$ref = any;
export type SetOrderAddressInput = {|
  city: string,
  countryCode: string,
  firstName: string,
  lastName: string,
  line1: string,
  line2?: ?string,
  orderId: string,
  phone?: ?string,
  postalCode: string,
  title?: ?string,
|};
export type SetOrderAddressMutationVariables = {|
  input: SetOrderAddressInput
|};
export type SetOrderAddressMutationResponse = {|
  +setOrderAddress: ?{|
    +order: ?{|
      +id: string,
      +coupon: ?{|
        +code: ?string
      |},
      +address: ?{|
        +firstName: ?string,
        +lastName: ?string,
        +phone: ?string,
        +title: ?string,
        +city: ?string,
        +postalCode: ?string,
        +line1: ?string,
        +line2: ?string,
        +country: ?{|
          +alpha2: ?string
        |},
      |},
      +availablePaymentMethods: ?$ReadOnlyArray<?{|
        +id: string,
        +name: ?string,
        +defaultPaymentType: ?string,
      |}>,
      +bill: ?{|
        +$fragmentRefs: CheckoutBillTable_bill$ref
      |},
      +cart: ?{|
        +paymentRequired: ?boolean
      |},
      +state: ?string,
    |}
  |}
|};
export type SetOrderAddressMutation = {|
  variables: SetOrderAddressMutationVariables,
  response: SetOrderAddressMutationResponse,
|};
*/


/*
mutation SetOrderAddressMutation(
  $input: SetOrderAddressInput!
) {
  setOrderAddress(input: $input) {
    order {
      id
      coupon {
        code
      }
      address {
        firstName
        lastName
        phone
        title
        city
        postalCode
        line1
        line2
        country {
          alpha2
          id
        }
        id
      }
      availablePaymentMethods {
        id
        name
        defaultPaymentType
      }
      bill {
        ...CheckoutBillTable_bill
      }
      cart {
        paymentRequired
        id
      }
      state
    }
  }
}

fragment CartBillItem_billItem on BillItem {
  bruttoPrice
  discount
  lineItem {
    ...CartLineItem_lineItem
    id
  }
  price
  vat
}

fragment CartLineItemFotoFlat_lineItem on LineItem {
  media {
    mediaList(first: 50) {
      edges {
        node {
          variants {
            name
            url
            id
          }
          id
        }
      }
    }
  }
  product {
    event {
      name
      searchByFace
      id
    }
    id
  }
  productParams {
    __typename
    ... on FotoFlatParams {
      startnumber
    }
  }
}

fragment CartLineItemSinglePhoto_lineItem on LineItem {
  product {
    event {
      name
      id
    }
    id
  }
  productParams {
    __typename
    ... on SingleFotoParams {
      foto {
        sgId
        variants {
          name
          url
          id
        }
        id
      }
    }
  }
}

fragment CartLineItem_lineItem on LineItem {
  product {
    type
    id
  }
  ...CartLineItemFotoFlat_lineItem
  ...CartLineItemSinglePhoto_lineItem
}

fragment CheckoutBillTable_bill on Bill {
  charges
  items {
    id
    lineItem {
      product {
        type
        id
      }
      id
    }
    ...CartBillItem_billItem
  }
  coupon {
    vat
    brutto
    code
  }
  totalBruttoPrice
  totalBruttoPriceUnpayed
  totalNettoPrice
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetOrderAddressInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "coupon",
  "storageKey": null,
  "args": null,
  "concreteType": "Coupon",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "postalCode",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line1",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line2",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alpha2",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "availablePaymentMethods",
  "storageKey": null,
  "args": null,
  "concreteType": "PaymentMethod",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "defaultPaymentType",
      "args": null,
      "storageKey": null
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "paymentRequired",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "variants",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaFile",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/)
  ]
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vat",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SetOrderAddressMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setOrderAddress",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SetOrderAddressPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "order",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "country",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Country",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/)
                    ]
                  }
                ]
              },
              (v15/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bill",
                "storageKey": null,
                "args": null,
                "concreteType": "Bill",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "CheckoutBillTable_bill",
                    "args": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "cart",
                "storageKey": null,
                "args": null,
                "concreteType": "Cart",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetOrderAddressMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setOrderAddress",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SetOrderAddressPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "order",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "country",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Country",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v2/*: any*/)
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              (v15/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bill",
                "storageKey": null,
                "args": null,
                "concreteType": "Bill",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "charges",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BillItem",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "lineItem",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LineItem",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "product",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type",
                                "args": null,
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "event",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Event",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "searchByFace",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "media",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ExtendedMediaConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "mediaList",
                                "storageKey": "mediaList(first:50)",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 50
                                  }
                                ],
                                "concreteType": "MediaConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Media",
                                        "plural": false,
                                        "selections": [
                                          (v18/*: any*/),
                                          (v2/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "productParams",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "__typename",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "FotoFlatParams",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "startnumber",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "SingleFotoParams",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "foto",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Media",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "sgId",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v18/*: any*/),
                                      (v2/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "bruttoPrice",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "price",
                        "args": null,
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "coupon",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BillCoupon",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "brutto",
                        "args": null,
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalBruttoPrice",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalBruttoPriceUnpayed",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalNettoPrice",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "cart",
                "storageKey": null,
                "args": null,
                "concreteType": "Cart",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v2/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "SetOrderAddressMutation",
    "id": null,
    "text": "mutation SetOrderAddressMutation(\n  $input: SetOrderAddressInput!\n) {\n  setOrderAddress(input: $input) {\n    order {\n      id\n      coupon {\n        code\n      }\n      address {\n        firstName\n        lastName\n        phone\n        title\n        city\n        postalCode\n        line1\n        line2\n        country {\n          alpha2\n          id\n        }\n        id\n      }\n      availablePaymentMethods {\n        id\n        name\n        defaultPaymentType\n      }\n      bill {\n        ...CheckoutBillTable_bill\n      }\n      cart {\n        paymentRequired\n        id\n      }\n      state\n    }\n  }\n}\n\nfragment CartBillItem_billItem on BillItem {\n  bruttoPrice\n  discount\n  lineItem {\n    ...CartLineItem_lineItem\n    id\n  }\n  price\n  vat\n}\n\nfragment CartLineItemFotoFlat_lineItem on LineItem {\n  media {\n    mediaList(first: 50) {\n      edges {\n        node {\n          variants {\n            name\n            url\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n  product {\n    event {\n      name\n      searchByFace\n      id\n    }\n    id\n  }\n  productParams {\n    __typename\n    ... on FotoFlatParams {\n      startnumber\n    }\n  }\n}\n\nfragment CartLineItemSinglePhoto_lineItem on LineItem {\n  product {\n    event {\n      name\n      id\n    }\n    id\n  }\n  productParams {\n    __typename\n    ... on SingleFotoParams {\n      foto {\n        sgId\n        variants {\n          name\n          url\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CartLineItem_lineItem on LineItem {\n  product {\n    type\n    id\n  }\n  ...CartLineItemFotoFlat_lineItem\n  ...CartLineItemSinglePhoto_lineItem\n}\n\nfragment CheckoutBillTable_bill on Bill {\n  charges\n  items {\n    id\n    lineItem {\n      product {\n        type\n        id\n      }\n      id\n    }\n    ...CartBillItem_billItem\n  }\n  coupon {\n    vat\n    brutto\n    code\n  }\n  totalBruttoPrice\n  totalBruttoPriceUnpayed\n  totalNettoPrice\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '920328b95e6b50ed4e52f169cb2dfdaf';

module.exports = node;
